<app-backgrop>
  <div class="max-w-[90vw] max-h-[90vw] landscape:max-w-[80vh] landscape:max-h-[80vh] w-[700px] h-[700px] relative flex justify-center items-center">
    <img class="w-full h-full select-none pointer-events-none scale-[1.5] absolute top-[7%] left-[-2%] gap-4 z-1" src="./assets-compressed/categories/freid/match-three/board-water.svg" alt="">
    <img class="w-full h-full select-none pointer-events-none scale-[1.1] absolute top-[5%] left-0 gap-4 z-2" src="./assets-compressed/categories/freid/match-three/board.svg" alt="">
    <div class="w-full h-full relative z-3 flex flex-col gap-[3%] p-4 pt-5 pb-1">
      <div class="w-full h-[10.5%] flex justify-between px-[10px]">
        <div class="border-1 border-black text-(--custom-color-10) w-[90px] md:w-1/4 pl-1 pr-1 md:pl-2 md:pr-4 rounded-[7px] md:rounded-[14px] bg-(--main-color) active:bg-(--main-color-hover) transition-all duration-300 shadow-(--custom-bottom-shadow2) flex items-center justify-start"
            [class.cursor-pointer]="hintCount"
            (click)="hint()">
          <div class="select-none pointer-events-none flex items-center gap-2 mr-1" [class.opacity-50]="!hintCount">
            <app-icon class="size-5 md:size-10 fill-white" [iconName]="iconName.Lamp"></app-icon>
          </div>
          <b><span class="select-none pointer-events-none font-(family-name:--default-font-family2) text-white text-[15px] md:text-[30px]" [class.opacity-50]="!hintCount">{{hintCount}}</span></b>
        </div>
        <div class="self-center text-center w-1/3 font-(family-name:--default-font-family2) font-black text-3xl md:text-6xl text-(--custom-color-1)">
          00:{{timeLeft < 10 ? '0' + timeLeft : timeLeft}}
        </div>
        <div class="cursor-default font-(--custom-color-10) pl-1 pr-1 md:pl-2 md:pr-2 w-[95px] md:w-1/4 rounded-[7px] md:rounded-[14px] bg-[linear-gradient(to_bottom,#CFB5A6,#BA9E8E)]  shadow-(--custom-shadow2) flex items-center justify-between">
          <div class="flex items-center gap-2 mr-1">
            <app-icon class="size-5 md:size-10" [iconName]="iconName.Cards"></app-icon>
          </div>
          <b><span class="font-(family-name:--default-font-family2) text-(--custom-color-10) text-[15px] md:text-[27px]">{{currentMatches}}&nbsp;из&nbsp;10</span></b>
        </div>
      </div>
      <div class=" w-full h-[86%] rounded-lg bg-[linear-gradient(to_bottom,#C7A993_0%,#92837D_100%)] grid grid-cols-5 grid-rows-5 md:grid-cols-8 md:grid-rows-7 gap-[1px] p-1" id="board" [class.pointer-events-none]="showCenterText">
        @for (rows of board; track rows; let rowIndex = $index) {
          @for (col of rows; track col; let colIndex = $index) {
            @if (col != null) {
              <div class="flex justify-center items-center bg-(--custom-color-8) border-1 border rounded-lg
                       border-(--custom-color-9) select-none shadow-(--custom-shadow1) cursor-pointer transition-all duration-300 ease-in-out"
                      [class.bg-[linear-gradient(to_bottom,#CFB5A6,#BA9E8E)]]="showHint && col.hint || col.isSelect"
                      [class.shadow-(--custom-shadow2)]="col.isSelect"
                      [class.bg-white]="col.isRemoved"
                      [class.hover:bg-[linear-gradient(to_bottom,#CFB5A6,#BA9E8E)]]="!col.isRemoved"
                      [class.removed]="col.isRemoved"
                      (pointerdown)="startWatch($event, rowIndex, colIndex, col)"
                      (pointerover)="playHover()"
                      >
                      
                  <img class="max-w-8/10 max-h-8/10 select-none pointer-events-none" src="./assets-compressed/categories/freid/match-three/{{col.icon}}.png" alt="">
              </div>
            } @else {
              <div class="flex justify-center items-center bg-(--custom-color-8) border-1 border rounded-lg border-(--custom-color-9) shadow-(--custom-shadow1) cursor-pointer"></div>
            }
          }
        }
      </div>
    </div>
  </div>
</app-backgrop>
@if (showResult) {
  @if (isFail) {
    <app-result-modal-with-actions
      [type]="'failure'"
      (successClicked)="close()"
      (rejectClicked)="reset()"
    ></app-result-modal-with-actions>
  } @else {
    <app-result-modal-with-actions
      (successClicked)="close()"
      (rejectClicked)="reset()"
    ></app-result-modal-with-actions>
  }
}

@if (showCenterText) {
  <app-center-text class="relative z-1000" [params]="showCenterTextParam" [completedFn]="completedFn"/>
}